const faqItems = [
  {
    q: '51爆料的内容来源是什么？如何保证信息可靠性？',
    a: '51爆料每日大赛专区的内容来源于全网多个渠道的公开信息和用户投稿。我们的编辑团队采用 AI + 人工双重审核机制对所有内容进行核实与筛选，确保每一条爆料都经过严格的信息校验流程。对于尚未确认的消息，我们会标注「待核实」标签，方便读者自行判断。',
  },
  {
    q: '每日大赛的排行规则是怎样的？',
    a: '每日大赛排行综合考量多个维度，包括话题热度、讨论量、用户参与度、内容传播范围等。系统每小时自动更新排名数据，确保榜单反映最新的热点动态。排名规则透明公开，用户可以在规则说明页面查看详细的计分逻辑。',
  },
  {
    q: '如何向51爆料投稿？投稿有什么要求？',
    a: '你可以通过以下方式投稿：发送邮件至 tips@51baoliao.com，或在移动客户端中使用「一键爆料」功能。投稿内容需为原创或已获得授权，并附上相关证据或信息来源。我们的编辑团队会在 1-3 个工作日内完成审核，通过后会及时通知你。优质投稿将获得首页推荐位和积分奖励。',
  },
  {
    q: '51爆料移动客户端有哪些特色功能？',
    a: '51爆料移动客户端支持 iOS 和 Android 双平台，提供以下特色功能：实时推送通知确保热点不错过、离线阅读模式方便随时随地浏览、个性化话题订阅精准匹配兴趣领域、夜间模式保护视力、一键爆料快速投稿。客户端还独家支持语音播报功能，让你开车或运动时也能听爆料。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            常见问答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于51爆料，你可能想了解的问题
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/60">
          {faqItems.map((item, i) => (
            <div key={i} className="py-5 md:py-6">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 font-bold flex-shrink-0">Q{i + 1}.</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-7 md:pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}